import { createFileRoute } from '@tanstack/react-router';
import { ReferrerCreateSheet } from '@/pages/referrers/form';

export const Route = createFileRoute('/admin/_layout/referrers/_layout/new')({
  component: () => <ReferrerCreateSheet />,
});
